import React, { useEffect, useState } from "react";
import CustomTable from "../../components/CustomTable";
import { headDataDocuments } from "../../components/CustomTable/headData";
import {
  clasifEmpresaOptions,
  companyOptions,
  sunatStatusOptions,
  pagoStatusOptions,
  areaOptions,
  typeDocumentOptions,
  initDataUsuarioRimac,
  initDataProveedorRimac,
  initDataProveedor
} from "../../utils/options";
import Jumpbotron from "../../components/common/Jumpbotron";
import Step from "../../components/common/Step";
import Radio from "../../components/common/Radio";
import { iconDownloadHead } from "../../components/common/icons";
import Input from "../../components/common/Input";
import Select from "../../components/common/Select";
import Button from "../../components/common/Button";
import deleteLogo from "../../assets/gl_delete-20.svg";
import proveedores_jpg from "../../assets/edificio-rimac2.png";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import InputPicker from "../../components/common/InputPicker";
import { Auth } from "aws-amplify";
import moment from "moment";
import ExcelSchema from "../../components/common/ExcelSchema";
import "./styles.scss";
import { callService } from "../../amplify/callService";
import Modal from "../../components/common/Modal";
import { CONSTANTES } from "../../utils/Constantes";
import Validate from "../../utils/Validate";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../redux/actions/general";
import TableRimac from "../../components/common/Table/TableRimac";
import {
  iconDownloadUnavailable,
  iconDownload,
  iconFile,
  iconDeleteDropdown,
  iconEdit,
} from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import { getColorByStatusSunat } from "../../utils/utils";
import { profileUsers, statusUsers } from "../../utils/options";
import InputFile from "../../components/common/InputFile";
import CardItem from "../../components/common/CardItem";
import Alert from "../../components/common/Alert";
import Pagination from "../../components/common/Pagination";
import Checkbox from "../../components/common/Checkbox";
/*
const typesOfAdicFile =
  "image/*, application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/*, audio/*, video/* , text/plain";
*/
const itemsPerPage = 10;

const Proveedores = (props, handleEdit = () => {}) => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });

  const [data, setData] = useState(null);
  const [checkReporte, setCheckReporte] = useState(false);
  const [checkEmision, setCheckEmision] = useState(false);
  const [checkRecepcion, setCheckRecepcion] = useState(true);

  const [isInternalUser, setIsInternalUser] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [reporteData, setReporteData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [globalChecked, setGlobalCheked] = useState(false);
  const [tagBody, setTagBody] = useState("actions2");
  const [tagEmptyBody, setTagEmptyBody] = useState("500");
  const [selectedRow, setSelectedRow] = useState(null);
  const [groups, setGroups] = useState(null);
  const [files, setFiles] = useState([]);
  const [arrAreas, setArrAreas] = useState([]);
  const [arrTipoDoc, setArrTipoDoc] = useState([]);
  const [emptyModal, setEmptyModal] = useState(false);
  const [docReemplazo, setDocReemplazo] = useState("");
  const [username, setUsername] = useState("");
  const [validacion, setValidacion] = useState({});
  const [mensajeError, setMensajeError] = useState("");
  
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });

  const getDataFromCurrentUser = async () => {
    const currentUser = await Auth.currentAuthenticatedUser();
    console.log("currentUser", currentUser);
    const typeUser = currentUser?.attributes["custom:type_user"];
    const rucUser = currentUser?.attributes["custom:ruc"];
    setUsername(currentUser?.username);
    return { typeUser, rucUser };
  };

  const initialSetup = async () => {
    console.log("ENTRO ALTA Proveedores")
    const currentUser = await Auth.currentAuthenticatedUser();
    const roleUser =
      currentUser?.signInUserSession.accessToken.payload["cognito:groups"];
    setGroups(roleUser);
    setTableData([]);
    const { typeUser, rucUser } = await getDataFromCurrentUser();
    /*if (typeUser === "provider") {
      setData({
        ...data,
        ...initDataProveedorRimac,
        ruc: rucUser,
        typeUser: "PROVIDER",
      });
      setIsInternalUser(false);
    } else {
      setData({ ...data,...initDataUsuarioRimac, typeUser: "INTERNAL", ruc: "" });
      setIsInternalUser(true);
    }*/
  };

  useEffect(() => {
    initialSetup();
  }, []);

  useEffect(() => {
    
  }, [currentPage]);

  useEffect(() => {
    //getAreas();
    getTipoDocPN();
    setData({...initDataProveedor});
  }, []);

  const getAreas = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.getArea);
      if (response.ok && response.data && response.data.payload) {
        let areas = response.data.payload.map((el, index) => {
          return {
            value: el.ID,
            text: el.name,
          };
        });
        setArrAreas(areas);
      }
    } catch (ex) {
      console.log("Error al obtener areas", ex);
    }
  };
  const getTipoDocPN = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','TIPDOC'));
      if (response.ok && response.data && response.data.payload) {
        let tipdoc = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrTipoDoc(tipdoc);
      }
    } catch (ex) {
      console.log("Error al obtener tipdoc", ex);
    }
  };
  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };

  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);

  const handleChange = (name, value) => {
    if (name === "documentType") console.log(value);
    value = value.toUpperCase ? value.toUpperCase() : value;
    setData({ ...data, [name]: value });
    setValidacion({ ...validacion, [name]: false });
  };
  const handleGuardar = async () => { 
    let payload = {
      idpTipoDocumento: data.idpTipoDocumento,
      numDocumento: data.numDocumento,
      nombreRazonSocial: data.nombreRazonSocial,
      nombreComercial: data.nombreComercial,
      correoNotificacion: data.correoNotificacion,
      usuCreacion:  username    
    };
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.registrarUrlProveedor,
      fetchObj
    );    
    dispatch(hideLoading());
    console.log('response.data', response.data);    
    console.log("RESPONSE:", response);
    if (response.ok && response.data) {
      setEmptyModal(true);
      setTagEmptyBody("");
    }else if(response.networkError){
      setTableData([]);
      setEmptyModal(true);
      setTagEmptyBody("Network");
    }else {
      console.log("Error fetching data => ", response.message);
      setTableData([]);
      setEmptyModal(true);
      setTagEmptyBody("500"); 
      setMensajeError(response.message);
    }
  };

  const bodyModal = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">Aviso</h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <h4 className="title-05 margin-bottom-10">
            Se envio el correo con {" "}
            <span className="title-05 color-red">
              <strong>exito.</strong>
            </span>
          </h4>
        </div>
      </div>
    );
  };

  const bodyNetworkModal = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">Aviso</h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <h4 className="title-06 margin-bottom-10">
            Cantidad de datos a buscar no soportada, disminuir rango de busqueda.            
          </h4>
        </div>
      </div>
    );
  };
  const bodyErrorModal = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">Error</h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <h4 className="title-06 margin-bottom-10">
            {mensajeError}          
          </h4>
        </div>
      </div>
    );
  };

  const validarFormulario = () => {
    let resp = true;
    for (var name in data) {
      if (data.hasOwnProperty(name))
        if(!data[name] ){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
          //break;
        }
        if(name=='correoNotificacion' && !Validate.validarEmail(data[name])){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
        } 
        if(name=='numDocumento' && !Validate.validarDocumento(data.idpTipoDocumento,data[name])){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
        }        
    }
    return resp;
  }

  return (
    <div className="documents d-justify-center padding-bottom-16">
      {/* <> */}
      <Jumpbotron
        paths={["Alta", "Proveedores"]}
        titleBlack="REGISTRO Y ACTUALIZACION"
        titleRed="DE PROVEEDORES"
        subTitle="Aqui puedes realizar el registro del proveedor"
      />
      <div className="content-grilla">        
        <div
          // onSubmit={handleSearch}
          className="documents_criteria w100 margin-bottom-16"
        >  
          <div className={"step"}>
            <div className="step__contents w50" style={{"backgroundImage": `url(${proveedores_jpg})`, "backgroundRepeat": "no-repeat","backgroundSize": "contain", "margin":"30px"}}>
              
            </div>
            
            <div className="step__contents  w50">
            <h4 className="title-05 margin-bottom-16 margin-top-48">
              <b>Inicia tu proceso de <span class="title-red">Registro de Proveedor</span></b>
            </h4>
              <div className="w100 margin-bottom-16" > 
                <div className="d-justify-space-between d-flex-column-m w100">                  
                  <div className="documents_criteria_doc">
                    <InputWithDropdown
                      selectProps={{
                        label: "Tipo Doc",
                        selected: data && arrTipoDoc.find(obj=>obj.value==data.idpTipoDocumento),
                        onChange: (newValue) => handleChange("idpTipoDocumento", newValue.value),
                        items: arrTipoDoc,
                        hasError: validacion.idpTipoDocumento && '*',
                        classNameList: 'listLarge'
                      }}
                      inputProps={{
                        label: "Número Documento",
                        name: "numDocumento",
                        maxLength: "15",
                        value: data?.numDocumento,
                        customRegex: /^[a-zA-Z0-9]*$/,
                        onChange: (newValue) =>
                          handleChange("numDocumento", newValue),
                        hasError:  validacion.numDocumento && '*'
                      }}
                    />
                  </div>                 
                </div>                              
                <div className="d-justify-space-between d-flex-column-m w100">            
                  <div className="documents_criteria_typeTicket">
                      <Input
                        label="Nombre o Razón Social"
                        name="razonSocial"
                        maxLength="300"
                        // customRegex= {/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                        value={data?.nombreRazonSocial}
                        onChange={(newValue) => handleChange("nombreRazonSocial", newValue)}
                        hasError={validacion.nombreRazonSocial && '*'}                        
                      />
                    </div>
                </div>
                <div className="d-justify-space-between d-flex-column-m w100">            
                  <div className="documents_criteria_typeTicket">
                      <Input
                        label="Nombre Comercial"
                        name="nombreComercial"
                        maxLength="300"
                        customRegex= {/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                        value={data?.nombreComercial}
                        onChange={(newValue) => handleChange("nombreComercial", newValue)}
                        hasError={validacion.nombreComercial && '*'}                       
                      />
                    </div>
                </div>                
                <div className="d-justify-space-between d-flex-column-m w100">            
                  <div className="documents_criteria_typeTicket">
                      <Input
                        label="Correo Electronico Proveedor"
                        name="correoNotificacion"
                        maxLength="500"
                        customRegex= {/^[a-zA-Z0-9\.\-\_@\.]*$/}
                        value={data?.correoNotificacion}
                        onChange={(newValue) => handleChange("correoNotificacion", newValue)}
                        hasError={validacion.correoNotificacion && '*'}                         
                      />
                    </div>
                </div>
                <div className="d-justify-space-between d-flex-column-m w100">
                  <div className="documents_criteria_btns d-flex-end margin-bottom-16">
                    <div className="documents_btnSearch">
                      <Button
                        // type="submit"
                        primary
                        size="large"
                        onClick={()=>{
                          if(validarFormulario())
                            handleGuardar();
                        }}
                      >
                        Registrar
                      </Button>
                    </div>                  
                  </div>
                </div>                
              </div>
            </div>
          </div>
        </div>

        {showAlert.show && (
          <Alert
            title={showAlert.title}
            message={showAlert.message}
            type={showAlert.type}
            hasBg={true}
            position="top-right"
            handleClose={() => resetAlert()}
          />
        )}        
        {emptyModal && (
              <Modal
                className="rd--modal-info-files"
                onToggle={(value) => setEmptyModal(false)}
                visible={emptyModal}
                width={672}
                fullScreenMobile
                redHoverClosed
                onLabelClosed
                max12Padding
                footer={
                  <Button primary onClick={() => setEmptyModal(false)}>
                    Cerrar
                  </Button>
                }
              >
                {tagEmptyBody=="Network"
                ? bodyNetworkModal()
                : tagEmptyBody=="500"
                ? bodyErrorModal()
                :  bodyModal()}
              </Modal>
            )}
      </div>
    </div>
  );
};

export default Proveedores;